import { BASE_API_URL } from '@env';
import { useMutation } from 'react-query';
import { useUserStore } from '~providers/userStore/zustand';
import { CreatePaymentIntentPayload, PaymentIntentResponse } from '~types/api/event';

export function useCreatePaymentIntent() {
  return useMutation<PaymentIntentResponse, Error, CreatePaymentIntentPayload>(
    async (payloadBody: CreatePaymentIntentPayload) => {
      const token = useUserStore.getState().token;
      console.log(payloadBody, 'payloadBodypayloadBody');
      
      const response = await fetch(`${BASE_API_URL}events/${payloadBody.eventId}/create-payment-intent`, {
        method: 'POST',
        body: JSON.stringify(payloadBody),
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });

      if (!response.ok) {
        console.error('API Error Response:', response);
        const errorData = await response.json();
        throw new Error(errorData.message || errorData.detail || errorData);
      }

      const data = await response.json();
      console.log(data, token, payloadBody, 'responseresponseresponse');

      return data;
    },
  );
}
